import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { SearchPlaceComponent } from './search-place.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchPlaceComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    TranslateModule.forChild({
      isolate: false
    }),
    MatIconModule,
    MatButtonModule
  ],
  exports: [SearchPlaceComponent]
})
export class SearchPlaceComponentModule {}
